import { ref, readonly } from 'vue'
import type { File } from '@openapi'

const openFileId = ref<File['id'] | null>(null)
const cleanupFn = ref<undefined | (() => void)>()

export function useAdminAndDsrState(onCleanup?: () => void) {
  if (onCleanup) cleanupFn.value = onCleanup

  function setOpenFileId(id: File['id']) {
    openFileId.value = id
  }

  function clearOpenFileId() {
    openFileId.value = null
    cleanupFn.value?.()
    cleanupFn.value = undefined
  }

  return {
    openFileId: readonly(openFileId),
    setOpenFileId,
    clearOpenFileId,
  }
}
